var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "260.957px",
    height: "20.642px",
    viewBox: "0 0 260.957 20.642",
    enableBackground: "new 0 0 260.957 20.642",
    xmlSpace: "preserve",
    className: "ng-scope",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M0,20.642V0h6.169v2.808H3.121v15.025h3.048v2.809H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M16.104,18.866v-1.152c-0.816,0.864-1.968,1.296-3.12,1.296c-1.248,0-2.256-0.408-2.952-1.104 c-1.008-1.008-1.272-2.184-1.272-3.552V6.361h3.121v7.561c0,1.704,1.08,2.28,2.064,2.28c0.984,0,2.088-0.576,2.088-2.28V6.361h3.12 v12.505H16.104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M22.608,4.225V1.68H25.8v2.544H22.608z M22.656,18.866V6.361h3.121v12.505H22.656z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M33.265,13.513H30.96L30.192,1.776h3.864L33.265,13.513z M30.336,18.866v-3.552h3.577v3.552H30.336z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "accent",
    fill: "#BED600",
    d: "M36.84,20.642v-2.785h3.048V2.784H36.84V0h6.168v20.642H36.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M56.231,18.866c-2.28,0-3.336-1.632-3.336-3.384V8.785h-1.393V6.913h1.393V3.216h2.448v3.696h2.353v1.872 h-2.353v6.577c0,0.888,0.432,1.416,1.344,1.416h1.008v2.088H56.231z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M68.184,18.866v-7.465c0-1.848-1.08-2.664-2.448-2.664s-2.472,0.84-2.472,2.664v7.465h-2.448V1.776h2.448 v6.145c0.84-0.912,1.944-1.368,3.144-1.368c2.712,0,4.225,1.824,4.225,4.464v7.849H68.184z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M76.199,13.489c0,2.088,1.104,3.408,3.097,3.408c1.368,0,2.088-0.384,2.952-1.248l1.56,1.464 c-1.248,1.248-2.424,1.896-4.561,1.896c-3.048,0-5.472-1.608-5.472-6.241c0-3.936,2.04-6.216,5.16-6.216 c3.264,0,5.161,2.4,5.161,5.856v1.08H76.199z M81.336,10.129c-0.384-0.912-1.248-1.536-2.4-1.536c-1.152,0-2.04,0.624-2.424,1.536 c-0.24,0.552-0.288,0.912-0.312,1.656h5.473C81.648,11.041,81.576,10.681,81.336,10.129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M100.439,18.866v-1.224c-0.84,0.912-2.016,1.368-3.24,1.368c-1.248,0-2.28-0.408-3-1.104 c-0.936-0.912-1.224-2.064-1.224-3.433V6.697h2.448v7.417c0,1.896,1.08,2.712,2.448,2.712s2.52-0.84,2.52-2.712V6.697h2.448v12.169 H100.439z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M113.423,9.553c-0.552-0.552-0.984-0.816-1.824-0.816c-1.32,0-2.424,1.056-2.424,2.736v7.393h-2.448V6.697 h2.4v1.32c0.624-0.864,1.872-1.464,3.24-1.464c1.176,0,2.064,0.312,2.904,1.152L113.423,9.553z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M125.855,17.93c-0.672,0.672-1.752,1.08-2.977,1.08c-1.32,0-2.304-0.336-3.216-1.44v1.296h-2.4V1.776h2.448 v6.145c0.888-1.056,1.896-1.368,3.192-1.368c1.224,0,2.28,0.408,2.953,1.08c1.224,1.224,1.368,3.288,1.368,5.136 S127.08,16.706,125.855,17.93z M122.255,8.737c-2.208,0-2.544,1.872-2.544,4.032s0.336,4.057,2.544,4.057 c2.208,0,2.521-1.896,2.521-4.057S124.463,8.737,122.255,8.737z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M137.087,18.866v-1.104c-0.888,0.888-1.728,1.248-3.24,1.248s-2.52-0.36-3.264-1.104 c-0.624-0.648-0.96-1.584-0.96-2.616c0-2.041,1.416-3.504,4.2-3.504h3.216v-0.864c0-1.536-0.768-2.28-2.664-2.28 c-1.344,0-1.992,0.312-2.665,1.176l-1.608-1.512c1.152-1.344,2.352-1.752,4.368-1.752c3.336,0,5.017,1.416,5.017,4.176v8.137 H137.087z M137.039,13.489h-2.856c-1.44,0-2.184,0.648-2.184,1.752c0,1.104,0.696,1.729,2.232,1.729 c0.936,0,1.632-0.072,2.28-0.696c0.36-0.36,0.528-0.936,0.528-1.8V13.489z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M150.671,18.866v-7.417c0-1.896-1.08-2.712-2.448-2.712s-2.52,0.84-2.52,2.712v7.417h-2.448V6.697h2.4 v1.224c0.84-0.912,2.016-1.368,3.24-1.368c1.249,0,2.28,0.408,3,1.104c0.936,0.912,1.224,2.064,1.224,3.432v7.777H150.671z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M162.574,4.296V1.704h2.592v2.592H162.574z M162.646,18.866V6.697h2.448v12.169H162.646z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M176.399,18.866v-7.417c0-1.896-1.08-2.712-2.448-2.712s-2.52,0.84-2.52,2.712v7.417h-2.448V6.697h2.4 v1.224c0.84-0.912,2.016-1.368,3.24-1.368c1.248,0,2.28,0.408,3,1.104c0.937,0.912,1.225,2.064,1.225,3.432v7.777H176.399z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M186.55,19.01c-1.992,0-3.672-0.336-5.112-1.752l1.608-1.608c0.984,1.008,2.304,1.272,3.504,1.272 c1.488,0,2.664-0.528,2.664-1.68c0-0.816-0.455-1.344-1.631-1.44l-1.945-0.168c-2.279-0.192-3.6-1.224-3.6-3.36 c0-2.376,2.039-3.72,4.584-3.72c1.824,0,3.385,0.384,4.512,1.368l-1.535,1.56c-0.768-0.648-1.848-0.888-3-0.888 c-1.465,0-2.209,0.648-2.209,1.56c0,0.72,0.385,1.272,1.68,1.392l1.92,0.168c2.281,0.192,3.625,1.272,3.625,3.433 C191.615,17.689,189.455,19.01,186.55,19.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M197.974,18.866c-2.281,0-3.336-1.632-3.336-3.384V8.785h-1.393V6.913h1.393V3.216h2.447v3.696h2.352v1.872 h-2.352v6.577c0,0.888,0.432,1.416,1.344,1.416h1.008v2.088H197.974z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M202.486,4.296V1.704h2.592v2.592H202.486z M202.558,18.866V6.697h2.447v12.169H202.558z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M212.517,18.866c-2.279,0-3.336-1.632-3.336-3.384V8.785h-1.393V6.913h1.393V3.216h2.449v3.696h2.352v1.872 h-2.352v6.577c0,0.888,0.432,1.416,1.344,1.416h1.008v2.088H212.517z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M224.447,18.866v-1.224c-0.84,0.912-2.018,1.368-3.24,1.368c-1.248,0-2.281-0.408-3.002-1.104 c-0.936-0.912-1.223-2.064-1.223-3.433V6.697h2.447v7.417c0,1.896,1.08,2.712,2.449,2.712c1.367,0,2.52-0.84,2.52-2.712V6.697 h2.449v12.169H224.447z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M234.357,18.866c-2.279,0-3.336-1.632-3.336-3.384V8.785h-1.393V6.913h1.393V3.216h2.449v3.696h2.352v1.872 h-2.352v6.577c0,0.888,0.432,1.416,1.344,1.416h1.008v2.088H234.357z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M240.669,13.489c0,2.088,1.105,3.408,3.098,3.408c1.367,0,2.088-0.384,2.951-1.248l1.561,1.464 c-1.248,1.248-2.424,1.896-4.561,1.896c-3.049,0-5.473-1.608-5.473-6.241c0-3.936,2.041-6.216,5.16-6.216 c3.266,0,5.16,2.4,5.16,5.856v1.08H240.669z M245.806,10.129c-0.383-0.912-1.248-1.536-2.4-1.536s-2.039,0.624-2.424,1.536 c-0.24,0.552-0.287,0.912-0.313,1.656h5.473C246.119,11.041,246.046,10.681,245.806,10.129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "foreground",
    fill: "#FFFFFF",
    d: "M255.892,10.958c-2.799,0-5.064-2.267-5.064-5.065c0-2.798,2.266-5.065,5.064-5.065 s5.064,2.267,5.064,5.065C260.957,8.691,258.691,10.958,255.892,10.958z M255.892,1.765c-2.268,0-4.059,1.819-4.059,4.127 c0,2.309,1.791,4.128,4.059,4.128s4.043-1.819,4.043-4.128C259.935,3.583,258.16,1.765,255.892,1.765z M256.955,8.621l-1.119-2.168 h-0.699v2.168h-1.008V3.15h2.057c1.037,0,1.764,0.77,1.764,1.679c0,0.77-0.475,1.273-1.078,1.483l1.219,2.309H256.955z  M256.06,4.003h-0.924v1.651h0.924c0.531,0,0.895-0.364,0.895-0.826C256.955,4.367,256.591,4.003,256.06,4.003z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.dc208f6a6e594ac474fbdf1bfe31934f.svg";
export { ForwardRef as ReactComponent };